import { render, staticRenderFns } from "./userdetails.vue?vue&type=template&id=1ac79786&"
import script from "./userdetails.vue?vue&type=script&lang=js&"
export * from "./userdetails.vue?vue&type=script&lang=js&"
import style0 from "./userdetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports